import React from 'react';

interface ExcelIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ExcelIcon: React.FC<ExcelIconProps> = ({ 
  width = 20, 
  height = 20, 
  className 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="5" y="2" width="13" height="16" rx="2" fill="#33C481"/>
      <path d="M18 10V6H12V2H6.75C5.7835 2 5 2.7835 5 3.75V10H18Z" fill="#21A366"/>
      <path d="M5 10H18V14H5V10Z" fill="#107C41"/>
      <path d="M18 16V14H12V10H5V16C5 17.1046 5.89543 18 7 18H16C17.1046 18 18 17.1046 18 16Z" fill="#185C37"/>
      <path d="M5 6H12C12.5523 6 13 6.44772 13 7V14C13 15.1046 12.1046 16 11 16H5V6Z" fill="black" fillOpacity="0.5"/>
      <rect x="2" y="5" width="10" height="10" rx="1" fill="#107C41"/>
      <path d="M9.58633 12.9999H8.36025L7.15091 10.8742C7.12859 10.8379 7.10627 10.7905 7.08395 10.7319C7.06443 10.6733 7.0435 10.6036 7.02119 10.5227H7.00445C6.9905 10.5617 6.97237 10.6119 6.95005 10.6733C6.92773 10.7319 6.89844 10.8016 6.86217 10.8825L5.63191 12.9999H4.39746L6.36002 9.99124L4.56066 6.99927H5.81185L6.8538 8.95346C6.89007 9.0232 6.92355 9.09713 6.95423 9.17524C6.98771 9.25336 7.01979 9.33426 7.05048 9.41795H7.06722C7.0979 9.34263 7.12999 9.26451 7.16346 9.18361C7.19973 9.10271 7.23739 9.02042 7.27645 8.93672L8.39373 6.99927H9.54867L7.70746 9.9745L9.58633 12.9999Z" fill="white"/>
    </svg>
  );
};
